/**
 * 通用流程
 */

import request from '@/utils/request'

/**
 * 分页通用流程
 * @param data
 */
export function baseProcessSelect(data) {
  return request({
    url: '/base/process/select',
    method: 'post',
    data
  })
}

/**
 * 新增通用流程
 * @param data
 */
export function baseProcessSave(data) {
  return request({
    url: '/base/process/save',
    method: 'post',
    data
  })
}

/**
 * 修改通用流程
 * @param data
 */
export function baseProcessUpdate(data) {
  return request({
    url: '/base/process/update',
    method: 'post',
    data
  })
}

/**
 * 删除通用流程
 * @param ids (List<Long>)
 */
export function baseProcessDelete(ids) {
  return request({
    url: '/base/process/delete',
    method: 'post',
    data: { ids: ids }
  })
}

/**
 * 通用流程详情
 * @param id
 */
export function baseProcessSelectDetails(id) {
  return request({
    url: '/base/process/select/details',
    method: 'post',
    data: { id: id }
  })
}

/**
 * 推送流程信息
 * @param id
 */
export function pushProcess(id) {
  return request({
    url: '/base/process/push/process',
    method: 'post',
    data: { id: id }
  })
}
